define("shared/utils/country-list", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.getCountryListDiff = getCountryListDiff;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Lists all supported Countries and their country codes.
   * For use with Highcharts and Instagram Analytics data
   *
   * List is also used in address collection forms
   *
   */
  const getCountryList = intl => [{
    name: intl.t('analytics.countries.AF'),
    code: 'AF'
  }, {
    name: intl.t('analytics.countries.AX'),
    code: 'AX'
  }, {
    name: intl.t('analytics.countries.AL'),
    code: 'AL'
  }, {
    name: intl.t('analytics.countries.DZ'),
    code: 'DZ'
  }, {
    name: intl.t('analytics.countries.AS'),
    code: 'AS'
  }, {
    name: intl.t('analytics.countries.AD'),
    code: 'AD'
  }, {
    name: intl.t('analytics.countries.AO'),
    code: 'AO'
  }, {
    name: intl.t('analytics.countries.AI'),
    code: 'AI'
  }, {
    name: intl.t('analytics.countries.AQ'),
    code: 'AQ'
  }, {
    name: intl.t('analytics.countries.AG'),
    code: 'AG'
  }, {
    name: intl.t('analytics.countries.AR'),
    code: 'AR'
  }, {
    name: intl.t('analytics.countries.AM'),
    code: 'AM'
  }, {
    name: intl.t('analytics.countries.AW'),
    code: 'AW'
  }, {
    name: intl.t('analytics.countries.AU'),
    code: 'AU'
  }, {
    name: intl.t('analytics.countries.AT'),
    code: 'AT'
  }, {
    name: intl.t('analytics.countries.AZ'),
    code: 'AZ'
  }, {
    name: intl.t('analytics.countries.BS'),
    code: 'BS'
  }, {
    name: intl.t('analytics.countries.BH'),
    code: 'BH'
  }, {
    name: intl.t('analytics.countries.BD'),
    code: 'BD'
  }, {
    name: intl.t('analytics.countries.BB'),
    code: 'BB'
  }, {
    name: intl.t('analytics.countries.BY'),
    code: 'BY'
  }, {
    name: intl.t('analytics.countries.BE'),
    code: 'BE'
  }, {
    name: intl.t('analytics.countries.BQ'),
    code: 'BQ'
  }, {
    name: intl.t('analytics.countries.BZ'),
    code: 'BZ'
  }, {
    name: intl.t('analytics.countries.BJ'),
    code: 'BJ'
  }, {
    name: intl.t('analytics.countries.BL'),
    code: 'BL'
  }, {
    name: intl.t('analytics.countries.BM'),
    code: 'BM'
  }, {
    name: intl.t('analytics.countries.BT'),
    code: 'BT'
  }, {
    name: intl.t('analytics.countries.BO'),
    code: 'BO'
  }, {
    name: intl.t('analytics.countries.BA'),
    code: 'BA'
  }, {
    name: intl.t('analytics.countries.BW'),
    code: 'BW'
  }, {
    name: intl.t('analytics.countries.BV'),
    code: 'BV'
  }, {
    name: intl.t('analytics.countries.BR'),
    code: 'BR'
  }, {
    name: intl.t('analytics.countries.IO'),
    code: 'IO'
  }, {
    name: intl.t('analytics.countries.BN'),
    code: 'BN'
  }, {
    name: intl.t('analytics.countries.BG'),
    code: 'BG'
  }, {
    name: intl.t('analytics.countries.BF'),
    code: 'BF'
  }, {
    name: intl.t('analytics.countries.BI'),
    code: 'BI'
  }, {
    name: intl.t('analytics.countries.KH'),
    code: 'KH'
  }, {
    name: intl.t('analytics.countries.CM'),
    code: 'CM'
  }, {
    name: intl.t('analytics.countries.CA'),
    code: 'CA'
  }, {
    name: intl.t('analytics.countries.CV'),
    code: 'CV'
  }, {
    name: intl.t('analytics.countries.KY'),
    code: 'KY'
  }, {
    name: intl.t('analytics.countries.CF'),
    code: 'CF'
  }, {
    name: intl.t('analytics.countries.TD'),
    code: 'TD'
  }, {
    name: intl.t('analytics.countries.CL'),
    code: 'CL'
  }, {
    name: intl.t('analytics.countries.CN'),
    code: 'CN'
  }, {
    name: intl.t('analytics.countries.CX'),
    code: 'CX'
  }, {
    name: intl.t('analytics.countries.CC'),
    code: 'CC'
  }, {
    name: intl.t('analytics.countries.CO'),
    code: 'CO'
  }, {
    name: intl.t('analytics.countries.KM'),
    code: 'KM'
  }, {
    name: intl.t('analytics.countries.CG'),
    code: 'CG'
  }, {
    name: intl.t('analytics.countries.CD'),
    code: 'CD'
  }, {
    name: intl.t('analytics.countries.CK'),
    code: 'CK'
  }, {
    name: intl.t('analytics.countries.CR'),
    code: 'CR'
  }, {
    name: intl.t('analytics.countries.CI'),
    code: 'CI'
  }, {
    name: intl.t('analytics.countries.HR'),
    code: 'HR'
  }, {
    name: intl.t('analytics.countries.CU'),
    code: 'CU'
  }, {
    name: intl.t('analytics.countries.CW'),
    code: 'CW'
  }, {
    name: intl.t('analytics.countries.CY'),
    code: 'CY'
  }, {
    name: intl.t('analytics.countries.CZ'),
    code: 'CZ'
  }, {
    name: intl.t('analytics.countries.DK'),
    code: 'DK'
  }, {
    name: intl.t('analytics.countries.DJ'),
    code: 'DJ'
  }, {
    name: intl.t('analytics.countries.DM'),
    code: 'DM'
  }, {
    name: intl.t('analytics.countries.DO'),
    code: 'DO'
  }, {
    name: intl.t('analytics.countries.EC'),
    code: 'EC'
  }, {
    name: intl.t('analytics.countries.EG'),
    code: 'EG'
  }, {
    name: intl.t('analytics.countries.SV'),
    code: 'SV'
  }, {
    name: intl.t('analytics.countries.GQ'),
    code: 'GQ'
  }, {
    name: intl.t('analytics.countries.ER'),
    code: 'ER'
  }, {
    name: intl.t('analytics.countries.EE'),
    code: 'EE'
  }, {
    name: intl.t('analytics.countries.ET'),
    code: 'ET'
  }, {
    name: intl.t('analytics.countries.FK'),
    code: 'FK'
  }, {
    name: intl.t('analytics.countries.FO'),
    code: 'FO'
  }, {
    name: intl.t('analytics.countries.FJ'),
    code: 'FJ'
  }, {
    name: intl.t('analytics.countries.FI'),
    code: 'FI'
  }, {
    name: intl.t('analytics.countries.FR'),
    code: 'FR'
  }, {
    name: intl.t('analytics.countries.GF'),
    code: 'GF'
  }, {
    name: intl.t('analytics.countries.PF'),
    code: 'PF'
  }, {
    name: intl.t('analytics.countries.TF'),
    code: 'TF'
  }, {
    name: intl.t('analytics.countries.GA'),
    code: 'GA'
  }, {
    name: intl.t('analytics.countries.GM'),
    code: 'GM'
  }, {
    name: intl.t('analytics.countries.GE'),
    code: 'GE'
  }, {
    name: intl.t('analytics.countries.DE'),
    code: 'DE'
  }, {
    name: intl.t('analytics.countries.GH'),
    code: 'GH'
  }, {
    name: intl.t('analytics.countries.GI'),
    code: 'GI'
  }, {
    name: intl.t('analytics.countries.GR'),
    code: 'GR'
  }, {
    name: intl.t('analytics.countries.GL'),
    code: 'GL'
  }, {
    name: intl.t('analytics.countries.GD'),
    code: 'GD'
  }, {
    name: intl.t('analytics.countries.GP'),
    code: 'GP'
  }, {
    name: intl.t('analytics.countries.GU'),
    code: 'GU'
  }, {
    name: intl.t('analytics.countries.GT'),
    code: 'GT'
  }, {
    name: intl.t('analytics.countries.GG'),
    code: 'GG'
  }, {
    name: intl.t('analytics.countries.GN'),
    code: 'GN'
  }, {
    name: intl.t('analytics.countries.GW'),
    code: 'GW'
  }, {
    name: intl.t('analytics.countries.GY'),
    code: 'GY'
  }, {
    name: intl.t('analytics.countries.HT'),
    code: 'HT'
  }, {
    name: intl.t('analytics.countries.HM'),
    code: 'HM'
  }, {
    name: intl.t('analytics.countries.VA'),
    code: 'VA'
  }, {
    name: intl.t('analytics.countries.HN'),
    code: 'HN'
  }, {
    name: intl.t('analytics.countries.HK'),
    code: 'HK'
  }, {
    name: intl.t('analytics.countries.HU'),
    code: 'HU'
  }, {
    name: intl.t('analytics.countries.IS'),
    code: 'IS'
  }, {
    name: intl.t('analytics.countries.IN'),
    code: 'IN'
  }, {
    name: intl.t('analytics.countries.ID'),
    code: 'ID'
  }, {
    name: intl.t('analytics.countries.IR'),
    code: 'IR'
  }, {
    name: intl.t('analytics.countries.IQ'),
    code: 'IQ'
  }, {
    name: intl.t('analytics.countries.IE'),
    code: 'IE'
  }, {
    name: intl.t('analytics.countries.IM'),
    code: 'IM'
  }, {
    name: intl.t('analytics.countries.IL'),
    code: 'IL'
  }, {
    name: intl.t('analytics.countries.IT'),
    code: 'IT'
  }, {
    name: intl.t('analytics.countries.JM'),
    code: 'JM'
  }, {
    name: intl.t('analytics.countries.JP'),
    code: 'JP'
  }, {
    name: intl.t('analytics.countries.JE'),
    code: 'JE'
  }, {
    name: intl.t('analytics.countries.JO'),
    code: 'JO'
  }, {
    name: intl.t('analytics.countries.KZ'),
    code: 'KZ'
  }, {
    name: intl.t('analytics.countries.KE'),
    code: 'KE'
  }, {
    name: intl.t('analytics.countries.KI'),
    code: 'KI'
  }, {
    name: intl.t('analytics.countries.KP'),
    code: 'KP'
  }, {
    name: intl.t('analytics.countries.KR'),
    code: 'KR'
  }, {
    name: intl.t('analytics.countries.KW'),
    code: 'KW'
  }, {
    name: intl.t('analytics.countries.KG'),
    code: 'KG'
  }, {
    name: intl.t('analytics.countries.LA'),
    code: 'LA'
  }, {
    name: intl.t('analytics.countries.LV'),
    code: 'LV'
  }, {
    name: intl.t('analytics.countries.LB'),
    code: 'LB'
  }, {
    name: intl.t('analytics.countries.LS'),
    code: 'LS'
  }, {
    name: intl.t('analytics.countries.LR'),
    code: 'LR'
  }, {
    name: intl.t('analytics.countries.LY'),
    code: 'LY'
  }, {
    name: intl.t('analytics.countries.LI'),
    code: 'LI'
  }, {
    name: intl.t('analytics.countries.LT'),
    code: 'LT'
  }, {
    name: intl.t('analytics.countries.LU'),
    code: 'LU'
  }, {
    name: intl.t('analytics.countries.MF'),
    code: 'MF'
  }, {
    name: intl.t('analytics.countries.MO'),
    code: 'MO'
  }, {
    name: intl.t('analytics.countries.MK'),
    code: 'MK'
  }, {
    name: intl.t('analytics.countries.MG'),
    code: 'MG'
  }, {
    name: intl.t('analytics.countries.MW'),
    code: 'MW'
  }, {
    name: intl.t('analytics.countries.MY'),
    code: 'MY'
  }, {
    name: intl.t('analytics.countries.MV'),
    code: 'MV'
  }, {
    name: intl.t('analytics.countries.ML'),
    code: 'ML'
  }, {
    name: intl.t('analytics.countries.MT'),
    code: 'MT'
  }, {
    name: intl.t('analytics.countries.MH'),
    code: 'MH'
  }, {
    name: intl.t('analytics.countries.MQ'),
    code: 'MQ'
  }, {
    name: intl.t('analytics.countries.MR'),
    code: 'MR'
  }, {
    name: intl.t('analytics.countries.MU'),
    code: 'MU'
  }, {
    name: intl.t('analytics.countries.YT'),
    code: 'YT'
  }, {
    name: intl.t('analytics.countries.MX'),
    code: 'MX'
  }, {
    name: intl.t('analytics.countries.FM'),
    code: 'FM'
  }, {
    name: intl.t('analytics.countries.MD'),
    code: 'MD'
  }, {
    name: intl.t('analytics.countries.MC'),
    code: 'MC'
  }, {
    name: intl.t('analytics.countries.MN'),
    code: 'MN'
  }, {
    name: intl.t('analytics.countries.ME'),
    code: 'ME'
  }, {
    name: intl.t('analytics.countries.MS'),
    code: 'MS'
  }, {
    name: intl.t('analytics.countries.MA'),
    code: 'MA'
  }, {
    name: intl.t('analytics.countries.MZ'),
    code: 'MZ'
  }, {
    name: intl.t('analytics.countries.MM'),
    code: 'MM'
  }, {
    name: intl.t('analytics.countries.NA'),
    code: 'NA'
  }, {
    name: intl.t('analytics.countries.NR'),
    code: 'NR'
  }, {
    name: intl.t('analytics.countries.NP'),
    code: 'NP'
  }, {
    name: intl.t('analytics.countries.NL'),
    code: 'NL'
  }, {
    name: intl.t('analytics.countries.AN'),
    code: 'AN'
  }, {
    name: intl.t('analytics.countries.NC'),
    code: 'NC'
  }, {
    name: intl.t('analytics.countries.NZ'),
    code: 'NZ'
  }, {
    name: intl.t('analytics.countries.NI'),
    code: 'NI'
  }, {
    name: intl.t('analytics.countries.NE'),
    code: 'NE'
  }, {
    name: intl.t('analytics.countries.NG'),
    code: 'NG'
  }, {
    name: intl.t('analytics.countries.NU'),
    code: 'NU'
  }, {
    name: intl.t('analytics.countries.NF'),
    code: 'NF'
  }, {
    name: intl.t('analytics.countries.MP'),
    code: 'MP'
  }, {
    name: intl.t('analytics.countries.NO'),
    code: 'NO'
  }, {
    name: intl.t('analytics.countries.OM'),
    code: 'OM'
  }, {
    name: intl.t('analytics.countries.PK'),
    code: 'PK'
  }, {
    name: intl.t('analytics.countries.PW'),
    code: 'PW'
  }, {
    name: intl.t('analytics.countries.PS'),
    code: 'PS'
  }, {
    name: intl.t('analytics.countries.PA'),
    code: 'PA'
  }, {
    name: intl.t('analytics.countries.PG'),
    code: 'PG'
  }, {
    name: intl.t('analytics.countries.PY'),
    code: 'PY'
  }, {
    name: intl.t('analytics.countries.PE'),
    code: 'PE'
  }, {
    name: intl.t('analytics.countries.PH'),
    code: 'PH'
  }, {
    name: intl.t('analytics.countries.PN'),
    code: 'PN'
  }, {
    name: intl.t('analytics.countries.PL'),
    code: 'PL'
  }, {
    name: intl.t('analytics.countries.PT'),
    code: 'PT'
  }, {
    name: intl.t('analytics.countries.PR'),
    code: 'PR'
  }, {
    name: intl.t('analytics.countries.QA'),
    code: 'QA'
  }, {
    name: intl.t('analytics.countries.RE'),
    code: 'RE'
  }, {
    name: intl.t('analytics.countries.RO'),
    code: 'RO'
  }, {
    name: intl.t('analytics.countries.RU'),
    code: 'RU'
  }, {
    name: intl.t('analytics.countries.RW'),
    code: 'RW'
  }, {
    name: intl.t('analytics.countries.SH'),
    code: 'SH'
  }, {
    name: intl.t('analytics.countries.KN'),
    code: 'KN'
  }, {
    name: intl.t('analytics.countries.LC'),
    code: 'LC'
  }, {
    name: intl.t('analytics.countries.PM'),
    code: 'PM'
  }, {
    name: intl.t('analytics.countries.VC'),
    code: 'VC'
  }, {
    name: intl.t('analytics.countries.WS'),
    code: 'WS'
  }, {
    name: intl.t('analytics.countries.SM'),
    code: 'SM'
  }, {
    name: intl.t('analytics.countries.ST'),
    code: 'ST'
  }, {
    name: intl.t('analytics.countries.SA'),
    code: 'SA'
  }, {
    name: intl.t('analytics.countries.SN'),
    code: 'SN'
  }, {
    name: intl.t('analytics.countries.RS'),
    code: 'RS'
  }, {
    name: intl.t('analytics.countries.SS'),
    code: 'SS'
  }, {
    name: intl.t('analytics.countries.SC'),
    code: 'SC'
  }, {
    name: intl.t('analytics.countries.SL'),
    code: 'SL'
  }, {
    name: intl.t('analytics.countries.SG'),
    code: 'SG'
  }, {
    name: intl.t('analytics.countries.SK'),
    code: 'SK'
  }, {
    name: intl.t('analytics.countries.SI'),
    code: 'SI'
  }, {
    name: intl.t('analytics.countries.SB'),
    code: 'SB'
  }, {
    name: intl.t('analytics.countries.SO'),
    code: 'SO'
  }, {
    name: intl.t('analytics.countries.ZA'),
    code: 'ZA'
  }, {
    name: intl.t('analytics.countries.GS'),
    code: 'GS'
  }, {
    name: intl.t('analytics.countries.ES'),
    code: 'ES'
  }, {
    name: intl.t('analytics.countries.LK'),
    code: 'LK'
  }, {
    name: intl.t('analytics.countries.SD'),
    code: 'SD'
  }, {
    name: intl.t('analytics.countries.SR'),
    code: 'SR'
  }, {
    name: intl.t('analytics.countries.SJ'),
    code: 'SJ'
  }, {
    name: intl.t('analytics.countries.SX'),
    code: 'SX'
  }, {
    name: intl.t('analytics.countries.SZ'),
    code: 'SZ'
  }, {
    name: intl.t('analytics.countries.SE'),
    code: 'SE'
  }, {
    name: intl.t('analytics.countries.CH'),
    code: 'CH'
  }, {
    name: intl.t('analytics.countries.SY'),
    code: 'SY'
  }, {
    name: intl.t('analytics.countries.TW'),
    code: 'TW'
  }, {
    name: intl.t('analytics.countries.TJ'),
    code: 'TJ'
  }, {
    name: intl.t('analytics.countries.TZ'),
    code: 'TZ'
  }, {
    name: intl.t('analytics.countries.TH'),
    code: 'TH'
  }, {
    name: intl.t('analytics.countries.TL'),
    code: 'TL'
  }, {
    name: intl.t('analytics.countries.TG'),
    code: 'TG'
  }, {
    name: intl.t('analytics.countries.TK'),
    code: 'TK'
  }, {
    name: intl.t('analytics.countries.TO'),
    code: 'TO'
  }, {
    name: intl.t('analytics.countries.TT'),
    code: 'TT'
  }, {
    name: intl.t('analytics.countries.TN'),
    code: 'TN'
  }, {
    name: intl.t('analytics.countries.TR'),
    code: 'TR'
  }, {
    name: intl.t('analytics.countries.TM'),
    code: 'TM'
  }, {
    name: intl.t('analytics.countries.TC'),
    code: 'TC'
  }, {
    name: intl.t('analytics.countries.TV'),
    code: 'TV'
  }, {
    name: intl.t('analytics.countries.UG'),
    code: 'UG'
  }, {
    name: intl.t('analytics.countries.UA'),
    code: 'UA'
  }, {
    name: intl.t('analytics.countries.AE'),
    code: 'AE'
  }, {
    name: intl.t('analytics.countries.GB'),
    code: 'GB'
  }, {
    name: intl.t('analytics.countries.US'),
    code: 'US'
  }, {
    name: intl.t('analytics.countries.UM'),
    code: 'UM'
  }, {
    name: intl.t('analytics.countries.UY'),
    code: 'UY'
  }, {
    name: intl.t('analytics.countries.UZ'),
    code: 'UZ'
  }, {
    name: intl.t('analytics.countries.VU'),
    code: 'VU'
  }, {
    name: intl.t('analytics.countries.VE'),
    code: 'VE'
  }, {
    name: intl.t('analytics.countries.VN'),
    code: 'VN'
  }, {
    name: intl.t('analytics.countries.VG'),
    code: 'VG'
  }, {
    name: intl.t('analytics.countries.VI'),
    code: 'VI'
  }, {
    name: intl.t('analytics.countries.WF'),
    code: 'WF'
  }, {
    name: intl.t('analytics.countries.EH'),
    code: 'EH'
  }, {
    name: intl.t('analytics.countries.YE'),
    code: 'YE'
  }, {
    name: intl.t('analytics.countries.ZM'),
    code: 'ZM'
  }, {
    name: intl.t('analytics.countries.ZW'),
    code: 'ZW'
  }].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  var _default = _exports.default = getCountryList;
  /**
   * Fetches a complete list of countries and compares with our in app list, returning any we are missing.
   * We need to manually maintain our list of countries so this should be used periodically to ensure we are up to date.
   * The easiest usage is to run this on a route where we are loading the countries list and logging the output.
   *
   * Note: Rest Countries api that is used here to get the complete country list includes Kosovo,
   * however Kosovo is not included in SmartyStreets api so will not pass our country validation so we are not
   * including it in our in app countries list.
   *
   */
  async function getCountryListDiff(ourCountries) {
    const req = await fetch('https://restcountries.com/v3.1/all');
    const countryList = await req.json();
    const formattedCountries = countryList.map(c => ({
      code: c.cca2,
      name: c.name?.common
    }));
    return formattedCountries.filter(c => !ourCountries.findBy('code', c.code));
  }
});